module.exports = __webpack_public_path__ + "fonts/531c5a28-5575-4f58-96d4-a80f7b702d7b.4622c99.woff2";